import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING,
    EDIT_BOOKING,
    EDIT_BOOKING_SUCCESS,
    EDIT_BOOKING_FAILED,
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import {
    cloud_function_server_url,
  } from '../../config';
import { store } from '../store/store';
import { fetchBookings } from "./bookinglistactions";

const END_POINT = `${cloud_function_server_url}/booking`;

export const clearBooking = () => (dispatch) => (firebase) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

const padLeadingZeros = (num, size) => {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
}

// export const addBooking = (bookingData) => (dispatch) => (firebase) => {

//     const {
//         bookingRef,
//         bookingListRef
//     } = firebase;

//     dispatch({
//         type: CONFIRM_BOOKING,
//         payload: bookingData,
//     });

//     // var bookingsCount = 0;


//     // bookingListRef('', 'admin').once("value", (snapshot) => {

//     //     if (snapshot.val()) {
//     //         bookingsCount = snapshot.numChildren();
//     //     }

//     let pickUp = { lat: bookingData.pickup.coords.lat, lng: bookingData.pickup.coords.lng, add: bookingData.pickup.description };
//     let drop = { lat: bookingData.drop.coords.lat, lng: bookingData.drop.coords.lng, add: bookingData.drop.description };
//     var otp;
//     if (bookingData.settings.otp_secure)
//         otp = Math.floor(Math.random() * 9000) + 1000;
//     else {
//         otp = false;
//     }
//     let today = new Date().toString();
//     var token = "";
//     if (bookingData.userDetails.profile.pushToken) {
//         token = bookingData.userDetails.profile.pushToken;
//     }
//     var cartype = bookingData.carDetails.name;
//     var selectedimage = bookingData.carDetails.selectedImage;
//     if (typeof bookingData.carDetails === 'object' && bookingData.carDetails.length > 0) {
//         cartype = '';
//         selectedimage = '';
//         if (bookingData.booking_type_web) {
//             bookingData.carDetails.map((item, index) => {
//                 if (index === 0) {
//                     cartype = item.name;
//                     selectedimage = item.selectedImage;
//                 } else {
//                     cartype = cartype + ', ' + item.name;
//                     selectedimage = selectedimage + ', ' + item.selectedImage;
//                 }
//             });
//         } else {
//             bookingData.carDetails.map((item, index) => {
//                 if (index === 0) {
//                     cartype = item.carDetails.name;
//                     selectedimage = item.carDetails.selectedImage;
//                 } else {
//                     cartype = cartype + ', ' + item.carDetails.name;
//                     selectedimage = selectedimage + ', ' + item.carDetails.selectedImage;
//                 }
//             });
//         }
//     };

//     var count = (bookingData.bookingsCount + 1);
//     var adminNumber = padLeadingZeros(count, 8);
//     var adminBookingNumber = 'ZTBK' + adminNumber;
//     var driverNumber = padLeadingZeros(count, 4);
//     var driverBookingNumber = 'ZTCR' + driverNumber;

//     var data = {
//         booking_number: adminBookingNumber, // customer and admin view this number
//         driver_booking_number: driverBookingNumber, // driver and operator view this number
//         carType: cartype,
//         carImage: selectedimage,
//         carTypeName: bookingData.carTypeName,
//         customer: bookingData.userDetails.uid,
//         customer_name: bookingData.userDetails.profile.firstName + ' ' + bookingData.userDetails.profile.lastName,
//         customer_contact: bookingData.userDetails.profile.mobile,
//         customer_token: token,
//         customer_image: bookingData.userDetails.profile.profileImage ? bookingData.userDetails.profile.profileImage : "",
//         drop: drop,
//         pickup: pickUp,
//         estimate: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateFare : bookingData.estimate.estimateFare,
//         estimateDistance: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateDistance : bookingData.estimate.estimateDistance,
//         estimateTime: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateTime : bookingData.estimate.estimateTime,
//         status: "NEW",
//         bookLater: bookingData.bookLater,
//         tripdate: bookingData.bookLater ? bookingData.tripdate : today,
//         bookingDate: today,
//         startOtp: otp,
//         booking_type_web: bookingData.booking_type_web,
//         coords: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].waypoints : bookingData.estimate.waypoints,
//         book_type: bookingData.bookType ? bookingData.bookType : "Local",
//         passenger_count: bookingData.passengerCount ? bookingData.passengerCount : 1,
//         driver_name: bookingData.driverDetails ? bookingData.driverDetails.firstName + ' ' + bookingData.driverDetails.lastName : "",
//     }

//     bookingRef.push(data).then((res) => {
//         var bookingKey = res.key;

//         dispatch({
//             type: CONFIRM_BOOKING_SUCCESS,
//             payload: {
//                 booking_id: bookingKey,
//                 mainData: data,
//             }
//         });
//     }).catch(error => {
//         dispatch({
//             type: CONFIRM_BOOKING_FAILED,
//             payload: error.code + ": " + error.message,
//         });
//     });
//     // });
// };

export const addBooking = (bookingData) => (dispatch) => (firebase) => {

    // const {
    //     bookingRef,
    //     bookingListRef
    // } = Firebases;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    // var bookingsCount = 0;


    // bookingListRef('', 'admin').once("value", (snapshot) => {

    //     if (snapshot.val()) {
    //         bookingsCount = snapshot.numChildren();
    //     }

    let pickUp = { lat: bookingData.pickup.coords.lat, lng: bookingData.pickup.coords.lng, add: bookingData.pickup.description };
    let drop = { lat: bookingData.drop.coords.lat, lng: bookingData.drop.coords.lng, add: bookingData.drop.description };
    var otp;
    if (bookingData.settings.otp_secure)
        otp = Math.floor(Math.random() * 9000) + 1000;
    else {
        otp = false;
    }
    let today = new Date().toString();
    var token = "";
    if (bookingData.userDetails.profile.pushToken) {
        token = bookingData.userDetails.profile.pushToken;
    }
    // var cartype = bookingData.carDetails.name;
    // var selectedimage = bookingData.carDetails.selectedImage;
    // if (typeof bookingData.carDetails === 'object' && bookingData.carDetails.length > 0) {
    //     cartype = '';
    //     selectedimage = '';
    //     if (bookingData.booking_type_web) {
    //         bookingData.carDetails.map((item, index) => {
    //             if (index === 0) {
    //                 cartype = item.name;
    //                 selectedimage = item.selectedImage;
    //             } else {
    //                 cartype = cartype + ', ' + item.name;
    //                 selectedimage = selectedimage + ', ' + item.selectedImage;
    //             }
    //         });
    //     } else {
    //         bookingData.carDetails.map((item, index) => {
    //             if (index === 0) {
    //                 cartype = item.carDetails.name;
    //                 selectedimage = item.carDetails.selectedImage;
    //             } else {
    //                 cartype = cartype + ', ' + item.carDetails.name;
    //                 selectedimage = selectedimage + ', ' + item.carDetails.selectedImage;
    //             }
    //         });
    //     }
    // };

    var count = (bookingData.bookingsCount + 1);
    var adminNumber = padLeadingZeros(count, 8);
    var adminBookingNumber = 'ZTBK' + adminNumber;
    var driverNumber = padLeadingZeros(count, 4);
    var driverBookingNumber = 'ZTCR' + driverNumber;

    var data = {
        booking_number: adminBookingNumber, // customer and admin view this number
        driver_booking_number: driverBookingNumber, // driver and operator view this number
        // carType: cartype,
        // carImage: selectedimage,
        carTypeName: bookingData.carTypeName,
        customer: bookingData.userDetails.uid,
        customer_name: bookingData.userDetails.profile.firstName + ' ' + bookingData.userDetails.profile.lastName,
        customer_contact: bookingData.userDetails.profile.mobile,
        customer_token: token,
        customer_image: bookingData.userDetails.profile.profile_image ? bookingData.userDetails.profile.profile_image : "",
        drop: drop,
        pickup: pickUp,
        estimate: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateFare : bookingData.estimate.estimateFare,
        estimateDistance: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateDistance : bookingData.estimate.estimateDistance,
        estimateTime: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateTime : bookingData.estimate.estimateTime,
        status: "NEW",
        bookLater: bookingData.bookLater,
        tripdate: bookingData.bookLater ? bookingData.tripdate : today,
        bookingDate: today,
        startOtp: otp,
        booking_type_web: bookingData.booking_type_web,
        coords: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].waypoints : bookingData.estimate.waypoints,
        book_type: bookingData.bookType ? bookingData.bookType : "Local",
        passenger_count: bookingData.passengerCount ? bookingData.passengerCount : 1,
        driver_name: bookingData.driverDetails ? bookingData.driverDetails.firstName + ' ' + bookingData.driverDetails.lastName : "",
        driver_uid: bookingData.driverDetails ? bookingData.driverDetails.uid : "",
    }

    fetch(`${END_POINT}/add-booking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data })
    })
        .then(async (res) => {
            const response = await res.json();
            if (response?.success) {
                dispatch({
                    type: CONFIRM_BOOKING_SUCCESS,
                    payload: {
                        booking_id: response.data,
                        mainData: data,
                    }
                });
                // if(response.triggerMessage) {
                //     Alert.alert("Your outstation booking has been added.")
                // }
                fetchBookings()(dispatch)(firebase);
            }
        }).catch(error => {
            console.log("error booking", error)
            dispatch({
                type: CONFIRM_BOOKING_FAILED,
                payload: error.message,
            });
        });
};

export const addRentalBooking = (bookingData) => (dispatch) => (firebase) => {

    const {
        bookingRef,
        bookingListRef
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    // var bookingsCount = 0;

    // bookingListRef('', 'admin').once("value", (snapshot) => {
    //     if (snapshot.val()) {
    //         bookingsCount = snapshot.numChildren();
    //     }

    let pickUp = { lat: bookingData.pickup.lat, lng: bookingData.pickup.lng, add: bookingData.pickup.add };
    let today = new Date().toString();
    var token = "";
    if (bookingData.userDetails.profile.pushToken) {
        token = bookingData.userDetails.profile.pushToken;
    }
    var otp;
    if (bookingData.settings.otp_secure)
        otp = Math.floor(Math.random() * 9000) + 1000;
    else {
        otp = false;
    }
    var cartype = '';
    var selectedimage = '';

    if (typeof bookingData.carDetails === 'object' && bookingData.carDetails.length > 0) {
        cartype = '';
        selectedimage = '';
        bookingData.carDetails.map((item, index) => {
            if (index === 0) {
                cartype = item.carDetails.name;
                selectedimage = item.carDetails.selectedImage;
            } else {
                cartype = cartype + ', ' + item.carDetails.name;
                selectedimage = selectedimage + ', ' + item.carDetails.selectedImage;
            }
        });
    } else {
        cartype = bookingData.carDetails.name;
        selectedimage = bookingData.carDetails.selectedImage;
    }

    var count = (bookingData.bookingsCount + 1);
    var adminNumber = padLeadingZeros(count, 8);
    var adminBookingNumber = 'ZTBK' + adminNumber;
    var driverNumber = padLeadingZeros(count, 4);
    var driverBookingNumber = 'ZTCR' + driverNumber;

    var data = {
        booking_number: adminBookingNumber, // customer and admin view this number
        driver_booking_number: driverBookingNumber, // driver and operator view this number
        carType: cartype,
        carImage: selectedimage,
        carTypeName: bookingData.carTypeName,
        customer: bookingData.userDetails.uid,
        customer_name: bookingData.userDetails.profile.firstName + ' ' + bookingData.userDetails.profile.lastName,
        customer_contact: bookingData.userDetails.profile.mobile,
        customer_token: token,
        customer_image: bookingData.userDetails.profile.profileImage ? bookingData.userDetails.profile.profileImage : "",
        pickup: pickUp,
        estimate: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateFare : bookingData.estimate.estimateFare,
        estimateDistance: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateDistance : bookingData.estimate.estimateDistance,
        estimateTime: bookingData.carTypeName === 'any' ? bookingData.estimate[bookingData.estimate.length - 1].estimateTime : bookingData.estimate.estimateTime,
        status: "NEW",
        bookLater: bookingData.bookLater,
        tripdate: bookingData.bookLater ? bookingData.tripdate : today,
        bookingDate: today,
        booking_type_web: bookingData.booking_type_web,
        coords: [],
        startOtp: otp,
        book_type: bookingData.bookType ? bookingData.bookType : "Local",
        passenger_count: bookingData.passengerCount ? bookingData.passengerCount : 1,
        driver_name: bookingData.driverDetails ? bookingData.driverDetails.firstName + ' ' + bookingData.driverDetails.lastName : "",
    }

    bookingRef.push(data).then((res) => {
        var bookingKey = res.key;

        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id: bookingKey,
                mainData: data,
            }
        });
    }).catch(error => {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error.code + ": " + error.message,
        });
    });

    // });
};

export const editBooking = (oldbookingData, bookingData) => (dispatch) => (firebase) => {
    console.log("bookingData", bookingData)
    const {
        singleBookingRef,
        usersRef
    } = firebase;
    dispatch({
        type: EDIT_BOOKING,
        payload: bookingData
    });
    let editdata = bookingData;
    delete editdata.id;

    fetch(`${END_POINT}/update-booking/${oldbookingData.id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookingData: bookingData })
    })
        .then(async (res) => {
            const response = await res.json();
            fetchBookings()(dispatch)(firebase)
            console.log("resp updateOneBooking", response)
            dispatch({
                type: EDIT_BOOKING_SUCCESS,
                payload: null
            });
        }).catch(error => {
            console.log("driver cancel error", error);
            dispatch({
                type: EDIT_BOOKING_FAILED,
                payload: error
            });
        });

    // singleBookingRef(oldbookingData.id).update(editdata).then(() => {
    //     dispatch({
    //         type: EDIT_BOOKING_SUCCESS,
    //         payload: null
    //     });

    // }).catch((error) => {
    //     dispatch({
    //         type: EDIT_BOOKING_FAILED,
    //         payload: error
    //     });
    // });
}

